import { forwardRef } from "react";
import { Link, LinkProps } from "react-router-dom";

export const HelperAdapterLink = forwardRef<HTMLAnchorElement, LinkProps>(
  (props, ref) => <Link ref={ref as any} {...props} />,
);
